import { useEffect, useState } from "react";
import http from "../../http";
import CardEscolheMadeira from "../../Cards/CardEscolheMadeira";
import { Madeira } from "../../../interfaces/madeira.interface";
import Botao from "../../Botao";
import FormCortaMadeira from "../../Form/FormCortaMadeira";
import FormGastosProdutivos from "../../Form/FormGastosProdutivos";
import FormCriaProcesso from "../../Form/FormCriaProcesso";

export default function SectionIniciaProcesso() {
    const [madeiras, setMadeiras] = useState<Madeira[]>([]);

    const [indiceAtual, setIndiceAtual] = useState<number>(0); // Estado para controlar o índice
    const [sectionMadeiras, setSectionMadeiras] = useState<boolean>(false);
    const [sectionGastos, setSectionGastos] = useState<boolean>(false);
    const [showFormCriaProcesso, setShowFormCriaProcesso] = useState<boolean>(false);

    const [madeirasSelecionadas, setMadeirasSelecionadas] = useState<Madeira[]>([]);
    const [totalCortadoMadeira, setTotalCortadoMadeira] = useState<number>(0);

    //Despesas iniciais do processo
    const [gastosMadeira, setGastosMadeira] = useState<number>(0);
    const [depreciacao, setDepreciacao] = useState<number>(0);
    const [energia, setEnergia] = useState<number>(0);
    const [maoDeObra, setMaoDeObra] = useState<number>(0);
    //Quantidade restante de madeira no processo
    const [quantidadeFinal, setQuantidadeFinal] = useState<number>(0);


    const buscaDados = async () => {
        try {
            const dadosMadeiras = await http.get('madeiras');
            setMadeiras(dadosMadeiras.data);
        } catch (error) {
            console.error("Erro ao buscar dados:", error);
        }
    }

    const handleMadeiraClick = (madeira: Madeira) => {
        setMadeirasSelecionadas(prevState =>
            prevState.find(item => item.id === madeira.id)
                ? prevState.filter(item => item.id !== madeira.id)
                : [...prevState, madeira]
        );
    }

    const selecionaMadeira = () => {
        setSectionMadeiras(true);
        setIndiceAtual(0); // Começar sempre pelo primeiro item selecionado
    }

    const handleProximaMadeira = (custoMadeira: number, valorCortado: number) => {
        // Avança para a próxima madeira no array
        if (indiceAtual < madeirasSelecionadas.length - 1) {
            setGastosMadeira((prevGastosMadeira) => prevGastosMadeira + custoMadeira);
            setTotalCortadoMadeira((prevTotalCortadoMadeira) => prevTotalCortadoMadeira + valorCortado);
            setIndiceAtual(indiceAtual + 1);
        } else {
            setGastosMadeira((prevGastosMadeira) => prevGastosMadeira + custoMadeira);
            setTotalCortadoMadeira((prevTotalCortadoMadeira) => prevTotalCortadoMadeira + valorCortado);
            setSectionMadeiras(false)
            setSectionGastos(true);
        }
    }

    const getGastos = (depreciacao: number, energia: number, maoDeObra: number, quantidadeFinal: number) => {
        setShowFormCriaProcesso(true);
        setSectionGastos(false);
        setDepreciacao(depreciacao);
        setEnergia(energia);
        setMaoDeObra(maoDeObra);
        setQuantidadeFinal(quantidadeFinal);
    };

    useEffect(() => {
        buscaDados();
    }, []);

    return (
        <section>
            {!sectionMadeiras && !sectionGastos && !showFormCriaProcesso && (
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginLeft: '20px' }}>
                    <h1>Escolha a madeira</h1>
                    <h2>Madeiras selecionadas: {madeirasSelecionadas.map(item => item.COD).join(', ')}</h2>
                    <Botao text={'Próximo'} onClick={selecionaMadeira} />

                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '25px', marginTop: '20px' }}>
                        {madeiras.filter(madeira => madeira.ativo).map(madeira => (
                            <div
                                key={madeira.id}
                                onClick={() => handleMadeiraClick(madeira)}
                                style={{
                                    cursor: 'pointer',
                                    border: madeirasSelecionadas.some(item => item.id === madeira.id) ? '2px solid blue' : '1px solid grey',
                                    padding: '10px',
                                    margin: '5px',
                                }}
                            >
                                <CardEscolheMadeira madeira={madeira} />
                            </div>
                        ))}
                    </div>
                </div>
            )}

            <div style={{display: 'flex', justifyContent: 'center', width: '80vw', marginTop: 50}}>
                {sectionMadeiras && madeirasSelecionadas.length > 0 && (
                    <FormCortaMadeira
                        madeira={madeirasSelecionadas[indiceAtual]} // Renderiza a madeira atual
                        onProximaMadeira={handleProximaMadeira} // Função para avançar para a próxima madeira
                    />
                )}

                {sectionGastos &&
                    <FormGastosProdutivos
                        quantidadeEntrada={totalCortadoMadeira}
                        onGetGastos={getGastos}
                    />
                }

                {showFormCriaProcesso &&
                    <FormCriaProcesso
                        madeiras={madeirasSelecionadas}
                        depreciacao={depreciacao}
                        energia={energia}
                        maoDeObra={maoDeObra}
                        quantidadeFinal={quantidadeFinal}
                        despesaMadeira={gastosMadeira}
                    />
                }
            </div>
        </section>
    );
}
